import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'aiops-about-dialog',
  imports: [DialogModule, TranslatePipe],
  templateUrl: './about-dialog.html',
})
export class AboutDialog {
    @Input() aboutVisible: boolean = false;
    @Output() aboutVisibleChange = new EventEmitter<boolean>();
}
